import { render, staticRenderFns } from "./ChargeDetailTab.vue?vue&type=template&id=6670cc1c&scoped=true&"
import script from "./ChargeDetailTab.vue?vue&type=script&lang=js&"
export * from "./ChargeDetailTab.vue?vue&type=script&lang=js&"
import style0 from "./ChargeDetailTab.vue?vue&type=style&index=0&id=6670cc1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6670cc1c",
  null
  
)

export default component.exports